// import '../node_modules/bootstrap/dist/css/bootstrap.css'
// import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js'
import '../node_modules/bootstrap-icons/font/bootstrap-icons.css'
import { BasketContext } from './contexts/BasketContexts'
import { useEffect, useState } from 'react';
import { BasketPage } from './components/BasketPage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {Home} from './components/Home'

function App() {
  const [basket,setBasket] = useState(JSON.parse(localStorage.getItem('basket')) ?? [])

  useEffect(() =>
  {
      localStorage.setItem('basket', JSON.stringify(basket))
  }, [basket])

  return <BasketContext.Provider value={{basket,setBasket}}>
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="Basket" element={<BasketPage />} />
    </Routes>
    </BrowserRouter>
  </BasketContext.Provider>
}
export default App;